module.exports = __webpack_public_path__ + "babbef0a09f483eb1e82c31b229ba640.svg";